export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20dark%20background%20with%20warm%20golden%20and%20amber%20light%20streaks%2C%20soft%20film%20grain%20texture%2C%20elegant%20theater%20curtain%20folds%20in%20deep%20red%20and%20burgundy%2C%20minimalist%20atmospheric%20composition%2C%20dramatic%20stage%20lighting%2C%20premium%20cinema%20aesthetic&width=1920&height=1080&seq=hero-bg&orientation=landscape"
          alt="555电影网4K超清影视背景"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left w-full">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
              <i className="ri-sparkling-2-line text-accent-400 text-sm"></i>
              <span className="text-accent-300 text-sm font-medium">4K超清 · 流畅不缓冲</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-background-50 font-bold leading-tight mb-4">
              555电影网
              <span className="block text-accent-400 mt-2">4K超清影视在线平台</span>
            </h1>

            <p className="text-accent-300 text-lg md:text-xl font-medium mb-6">
              极致画质，不缓冲流畅观看
            </p>

            <div className="space-y-3 mb-8 max-w-lg mx-auto lg:mx-0">
              <p className="text-background-50/75 text-sm md:text-base leading-relaxed">
                555电影网致力于打造国内领先的4K超清影视平台，覆盖4K大片、超清剧集、纪录片、动漫等高品质影视资源。采用全球CDN加速与智能码率自适应技术，无论何时何地都能享受零卡顿的流畅观影体验。新片每日更新，经典持续修复，4K超清画质让每一帧都成为视觉盛宴。
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-6 md:gap-8 mb-8 justify-center lg:justify-start">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">20,000+</div>
                <div className="text-xs md:text-sm text-background-50/60 mt-1">4K影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-50/20"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">每日更新</div>
                <div className="text-xs md:text-sm text-background-50/60 mt-1">新片持续上线</div>
              </div>
              <div className="w-px h-10 bg-background-50/20"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">全球CDN</div>
                <div className="text-xs md:text-sm text-background-50/60 mt-1">流畅不卡顿</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <button
                onClick={() => handleScroll('#media')}
                className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                <i className="ri-play-circle-line mr-2"></i>
                开始观影
              </button>
              <button
                onClick={() => handleScroll('#features')}
                className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/15 text-background-50 font-medium text-base whitespace-nowrap cursor-pointer hover:bg-background-50/25 border border-background-50/20 transition-colors"
              >
                了解更多
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none mx-auto">
            <div className="relative">
              <div className="absolute -inset-4 bg-accent-500/10 rounded-3xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20composition%20with%20warm%20golden%20film%20strip%20elements%2C%20soft%20floating%20light%20particles%2C%20minimalist%20movie%20themed%20abstract%20art%2C%20deep%20burgundy%20and%20amber%20color%20palette%2C%20premium%20entertainment%20visual%2C%20sophisticated%20design%2C%20dark%20background%20with%20warm%20accents&width=800&height=1000&seq=hero-visual&orientation=portrait"
                alt="555电影网4K超清影视主题视觉"
                className="relative w-full h-auto rounded-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}